export const MAPPED_ALERTS = {
  login: {
    credentialsError: 'Email ou senha incorretos. Tente novamente',
  },
};
